import scopeIcon1 from '../../../assets/images/scope_1.png';
import scopeIcon2 from '../../../assets/images/scope_2.png';
import scopeIcon3 from '../../../assets/images/scope_3.png';
import scopeIcon4 from '../../../assets/images/scope_4.png';
import scopeIcon5 from '../../../assets/images/scope_5.png';
import scopeIcon6 from '../../../assets/images/scope_6.png';
import section7Bg from '../../../assets/images/about-section7.webp';
import { CONSULTATION_COPY } from '../../../constants/consultation';

export const cardsData = [
  {
    icon: scopeIcon1,
    title: 'Education and Certification',
    description:
      'Defines the level of training and qualifications a hypnotherapist has completed, such as foundational hypnotherapy training, clinical hypnotherapy, or specialized modalities like transpersonal hypnotherapy. Determines what services the practitioner is authorized to provide.',
  },
  {
    icon: scopeIcon2,
    title: 'Legal and Ethical Guidelines',
    description:
      'Aligns with local, state, and national regulations governing hypnotherapy practice. Ensures compliance with licensing requirements (if applicable) and ethical standards established by professional organizations.',
  },
  {
    icon: scopeIcon3,
    title: 'Competency Areas',
    description:
      'Emphasizes the importance of providing safe, client-centered care. Includes understanding when hypnosis is contraindicated, such as cases involving severe psychiatric conditions.',
  },
  {
    icon: scopeIcon4,
    title: 'Professional Boundaries',
    description:
      'Defines the limits of practice to prevent overserving into areas requiring additional licensure (e.g., psychotherapy). Reinforces collaboration with healthcare providers.',
  },
  {
    icon: scopeIcon5,
    title: 'Continuing Education',
    description:
      'Encourages ongoing learning to expand competencies while staying within the scope of practice. Includes obtaining CEUs to maintain certification.',
  },
  {
    icon: scopeIcon6,
    title: 'Protects Clients',
    description:
      'Ensures hypnotherapists deliver safe, ethical, and effective services. Clarifies responsibilities to help practitioners understand their scope of service.',
  },
];

export const clientJourney = [
  { id: 1, titleTop: 'Intake\nQuestionnaire', layout: 'textTop' },
  { id: 2, titleBottom: CONSULTATION_COPY.bookAUpper, layout: 'textBottom' },
  { id: 3, titleTop: 'Book Your Session', layout: 'textTop' },
  {
    id: 4,
    titleBottom: 'Fill Out Client Participation Agreement',
    layout: 'textBottom',
  },
  { id: 5, titleTop: 'Session(s)', layout: 'textTop' },
  { id: 6, titleBottom: 'Follow-Up', layout: 'textBottom' },
];

export const START_VIDEO_CONSULTATION = {
  backgroundImage: section7Bg,
  title: 'When The Mind Clears, Life\nTransforms In Its Reflection.',
  buttonText: CONSULTATION_COPY.start,
};
